import {useApi} from "../Api";
import {
    FormSearchLocationGroupLocationModel,
    LocationGroupLocation,
    LocationGroupLocations,
    LocationGroupLocationsSaveRequest
} from "../types/locationGroupLocation";
import {PagedResponse} from "../types/pagination";
import {buildQueryParams} from "../../utils";
import {Location} from "../types/location";

export const useLocationGroupLocationRepository = () => {
    const {GET, POST, DELETE} = useApi();

    const PATH = "/pricing/location-group-location";

    function postLocationGroupLocationAll(locationGroupLocations: LocationGroupLocation[]): Promise<LocationGroupLocation[]> {
        return POST(`${PATH}/full`, locationGroupLocations);
    }

    function postSaveLocationGroupLocationAll(locationGroupLocations: LocationGroupLocationsSaveRequest): Promise<LocationGroupLocation[]> {
        return POST(`${PATH}/save`, locationGroupLocations);
    }

    function getLocationGroupLocationsPaged(filters: FormSearchLocationGroupLocationModel): Promise<PagedResponse<LocationGroupLocations>> {
        const query = "?";

        const queryParams = buildQueryParams(filters);

        return GET(`${PATH}/filter${queryParams ? query + queryParams : ""}`);
    }

    function getLocationsByLocationGroup(groupId: number, legalEntity: string[]): Promise<Location[]> {
        return GET(`${PATH}/unassociated-ms-to-group?locationGroupId=${groupId}&legalEntities=${legalEntity}`);
    }

    function deleteLocationGroupLocation(locationGroupLocation: LocationGroupLocation): Promise<LocationGroupLocation[]> {
        return DELETE(`${PATH}?locationGroupId=${locationGroupLocation.id.locationGroupId}&locationId=${locationGroupLocation.id.locationId}`);
    }


    return {
        postSaveLocationGroupLocationAll,
        getLocationGroupLocationsPaged,
        getLocationsByLocationGroup,
        deleteLocationGroupLocation
    };
};